import { Phone } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { CONTACT } from "@/data/site";

export const PublicHeader = () => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-canvas-line bg-canvas/90 backdrop-blur-xl" data-testid="public-header">
    <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:px-8">
      <div className="flex items-center gap-4">
        <Logo testid="public-logo" />
        <span className="label-mono hidden leading-tight text-steel sm:block xl:hidden">Mechanical &amp;<br />Renewable Contractors</span>
      </div>
      <a href={`tel:${CONTACT.phones[0].tel}`} data-testid="public-header-phone"
        className="inline-flex h-11 items-center gap-2 border border-canvas-line px-4 font-display text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-colors duration-300 hover:border-brand hover:text-brand">
        <Phone className="h-4 w-4" /><span className="hidden sm:inline">Call</span> {CONTACT.phones[0].value}
      </a>
    </div>
  </header>
);
